import axiosPrivate from "./axiosPrivate";

const getServiciosProveedor = (proveedor_id = "") => {
  return axiosPrivate.get("proveedor-servicios", { params: { proveedor_id } }).then(res => res.data);
};

const guardarServicioProveedor = (data, id = null) => {
  const payload = {
    ...data,
    incluye_igv: data.incluye_igv ? 1 : 0,
  };

  if (id) {
    return axiosPrivate.post(`proveedor-servicios/${id}`, payload).then(res => res.data);
  }

  return axiosPrivate.post("proveedor-servicios", payload).then(res => res.data);
};

const eliminarServicioProveedor = (id) => {
  return axiosPrivate.delete(`proveedor-servicios/${id}`).then(res => res.data);
};

const ProveedorServiciosService = {
  getServiciosProveedor,
  guardarServicioProveedor,
  eliminarServicioProveedor,
};

export default ProveedorServiciosService;
